module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "menu-cover"
  }), _vm._v(" "), _c('div', {
    staticClass: "full-screen"
  }, [_c('div', {
    staticClass: "screen-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-locker-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "menu-nav"
  }, [_c('ul', {
    staticClass: "nav-list"
  }, [_vm._l((_vm.navArr), function(item) {
    return _c('li', {
      staticClass: "lock-nav-item active-nav-item"
    }, [_c('a', {
      staticClass: "locker-nav-a",
      attrs: {
        "href": item.url
      }
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.path == item.path),
        expression: "path == item.path"
      }],
      staticClass: "active-left-border"
    }), _vm._v(" "), _c('div', {
      staticClass: "locker-nav-cont border-after"
    }, [_c('span', {
      staticClass: "nav-icon"
    }, [_c('svg', {
      staticClass: "icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": item.icon
      }
    })])]), _vm._v(" "), _c('span', {
      staticClass: "locker-nav-option",
      class: {
        'active': _vm.path == item.path
      }
    }, [_vm._v(_vm._s(item.name))])])])])
  }), _vm._v(" "), _c('li', {
    staticClass: "lock-nav-item active-nav-item has-login-toggle has-logined"
  }, [_c('a', {
    staticClass: "locker-nav-a",
    attrs: {
      "href": _vm.logoutItem.url
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.path == _vm.logoutItem.path),
      expression: "path == logoutItem.path"
    }],
    staticClass: "active-left-border"
  }), _vm._v(" "), _c('div', {
    staticClass: "locker-nav-cont border-after"
  }, [_c('span', {
    staticClass: "nav-icon"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.logoutItem.icon
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "locker-nav-option",
    class: {
      'active': _vm.path == _vm.logoutItem.path
    }
  }, [_vm._v(_vm._s(_vm.logoutItem.name))])])])])], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "change-status"
  }, [_c('div', {
    staticClass: "imgs-title"
  }, [_c('img', {
    staticClass: "default-img portrait-img",
    attrs: {
      "src": "/static/img/yonghu-2.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "no-login-toggle"
  }, [_c('a', {
    attrs: {
      "href": "http://m.member.breadoffer.com/login.html"
    }
  }, [_vm._v("立即登录")])]), _vm._v(" "), _c('p', {
    staticClass: "has-login-toggle has-logined"
  }, [_c('a', {
    attrs: {
      "href": "http://m.member.breadoffer.com"
    }
  }, [_vm._v("进入会员中心")])]), _vm._v(" "), _c('a', {
    staticClass: "search-btn",
    attrs: {
      "href": "http://m.breadoffer.com/search.html?back=college&path=index"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-sousuo"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-604d494c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/menu.vue
// module id = 17
// module chunks = 8 9 10 11 12